export type ProductoMvp = {
  id: number;
  nombre: string;
  comercio: string;
  precio: string;
  cuota: string;
  rating: number;
  envio: string;
  tag?: string;
  descripcion: string;
};

export const MVP_PRODUCTOS: ProductoMvp[] = [
  {
    id: 1,
    nombre: "Mixer industrial 5L",
    comercio: "GastroBol",
    precio: "$ 489.999",
    cuota: "12x $ 40.833",
    rating: 4.6,
    envio: "Envío gratis",
    tag: "Full",
    descripcion: "Mixer robusto para gastronomía, cuerpo metálico, velocidad variable y bowl de 5L. Ideal para producción media/alta.",
  },
  {
    id: 2,
    nombre: "Pack luces LED local",
    comercio: "Electro Sur",
    precio: "$ 119.900",
    cuota: "6x $ 19.983",
    rating: 4.4,
    envio: "Llega hoy",
    descripcion: "Pack de iluminación LED para comercio con bajo consumo, tono neutro y alta durabilidad.",
  },
  {
    id: 3,
    nombre: "Terminal POS inalámbrica",
    comercio: "PagosPyme",
    precio: "$ 89.500",
    cuota: "9x $ 9.944",
    rating: 4.8,
    envio: "Retiro en comercio",
    tag: "Top",
    descripcion: "POS portátil con batería de larga duración, conexión Wi‑Fi/4G y soporte de cobros con QR y tarjetas.",
  },
  {
    id: 4,
    nombre: "Silla ergonómica premium",
    comercio: "Muebles Bolívar",
    precio: "$ 299.000",
    cuota: "12x $ 24.916",
    rating: 4.7,
    envio: "Envío gratis",
    descripcion: "Respaldo lumbar regulable, apoyabrazos 3D y materiales de alta resistencia para uso intensivo.",
  },
  {
    id: 5,
    nombre: "Impresora térmica tickets",
    comercio: "Tecno Punto",
    precio: "$ 155.000",
    cuota: "9x $ 17.222",
    rating: 4.5,
    envio: "Llega mañana",
    descripcion: "Impresora térmica de tickets de alta velocidad con corte automático y conectividad USB/Ethernet.",
  },
  {
    id: 6,
    nombre: "Kit seguridad CCTV x4",
    comercio: "Control House",
    precio: "$ 420.000",
    cuota: "12x $ 35.000",
    rating: 4.9,
    envio: "Envío gratis",
    tag: "Oferta",
    descripcion: "Kit con 4 cámaras HD, DVR, visión nocturna y acceso remoto desde app para monitoreo 24/7.",
  },
];
